import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// centralized-dispatch
import * as A from './actions';
//////////////////////////////////////////////////

const initialState = {
  filterSettings: [],
  tripsOrderFields: [],
  tripsSearchCriteria: [],
  driversSearchCriteria: [],
  driversRadiusRequestParams: {},
};

const getFilterSettingsSuccess = (state, filterSettings) => (
  P.$set('filterSettings', filterSettings, state)
);

const setTripsSearchCriteria = (state, searchCriteria) => (
  P.$set('tripsSearchCriteria', searchCriteria, state)
);

const setTripsOrderFields = (state, orderFields) => (
  P.$set('tripsOrderFields', orderFields, state)
);

const setDriversSearchCriteria = (state, searchCriteria) => (
  P.$set('driversSearchCriteria', searchCriteria, state)
);

const setDriversRadiusRequestParams = (state, requestParams) => (
  P.$set('driversRadiusRequestParams', requestParams, state)
);

export default createReducer({
  [A.setTripsOrderFields]: setTripsOrderFields,
  [A.setTripsSearchCriteria]: setTripsSearchCriteria,
  [A.setDriversSearchCriteria]: setDriversSearchCriteria,
  [A.getFilterSettingsSuccess]: getFilterSettingsSuccess,
  [A.setDriversRadiusRequestParams]: setDriversRadiusRequestParams,
}, initialState);
